<template>
  <el-breadcrumb
    class="p-3 pl-0 bg-white flex items-center ocr-breadcrumb"
    id="breadcrumb"
  >
    <el-breadcrumb-item
      v-for="(crumb, index) in crumbs"
      :key="index"
      :to="{ path: crumb.to }"
      :class="{'has-link': crumb.has_link}"
    >
      {{ crumb.text }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  computed: {
    crumbs: function() {
      const meta = this.$route.meta;
      var breadcrumbList = [];

      // For breadcrumb list
      if (meta.breadcrumbs) {
        for (let i in meta.breadcrumbs) {
          breadcrumbList.push({
            to: meta.breadcrumbs[i].path,
            text: meta.breadcrumbs[i].text,
            has_link: meta.breadcrumbs[i].path
          });
        }
      }

      // For simple breadcrumb
      if (meta.breadcrumb) {
        breadcrumbList.push({
          path: this.$route.path,
          to: this.$route.path,
          text: this.$route.meta.breadcrumb,
          has_link: false
        });
      }

      breadcrumbList.unshift({
        path: "/",
        to: "/",
        text: "ホーム",
        has_link: breadcrumbList.length
      })

      return breadcrumbList;
    },
  },
};
</script>
<style scoped>
  #breadcrumb {
    height: 60px;
  }

  .ocr-breadcrumb /deep/ .el-breadcrumb__inner,
  .ocr-breadcrumb /deep/ .el-breadcrumb__inner:hover,
  .ocr-breadcrumb /deep/ .el-breadcrumb__separator
  {
    font-size: 14px;
    line-height: 22px;
    color: #141414;
    font-weight: normal;
  }
  @media screen and (max-width: 821px) {
    .ocr-breadcrumb {
      padding: 12px 24px;
    }
  }
</style>
